export default {

    /**
     * isResume (required)
     */
    getLastSeekerInfo : {
        url: 'portal/recruit/seeker/getLastSeekerInfo'
    }

};
